import React, { Component } from 'react';
import Slider from "react-slick";

import LookWhosTalkingSlide from './LookWhosTalkingSlide';
import pressdata from '../../data/gate-fee-press';


class LookWhosTalkingSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            index: 0
        }

    }

    componentDidMount() {
        setInterval(this.selectIndex, 6000);
    }

    updateCounter = (index) => {
        this.setState({ index: index }, () => {
            clearInterval(this.selectIndex, 6000);
            setInterval(this.selectIndex, 6000);
        });
    }

    selectIndex = () => {
        let index = this.state.index;
        index++;
        if (index > 4) index = 0;
        this.setState({ index: index }, this.renderSlides);
    }

    renderSlides() {
        return pressdata.press.map((logo, index) => {
            let path = logo.path;
            return(
                <a target="_blank" href={ logo.link } key={index}>
                    <LookWhosTalkingSlide 
                        path={ path }
                        index={ index }
                    />
                </a>
            );
        });
    }

    render() {
        const sliderSettings = {
            // customPaging: function(i) {
            //         let path = "/images/explain/section9/" + sliderLogos[i];
            //         return(
            //             <a className="slider-logo-dot">
                            // <LookWhosTalkingSlide 
                                // index={i + 1}
                                // path={ path }
                            // />
            //             </a>
            //         );
            // },
            arrows: false,
            dots: false,
            dotsClass: 'slick-dots slider-logo-dots',
            infinite: true,
            speed: 500,         
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            className: 'ha-slider',
            // responsive: [
            //     {
            //       breakpoint: 479,
            //       settings: {
            //         slidesToShow: 3,
            //         slidesToScroll: 1
            //       }
            //     }
            // ]
        };

        // const sliderSettingsForPress = {
        //     arrows: true,
        //     dots: false,
        //     infinite: true,
        //     speed: 500,
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     autoplay: true,
        //     autoplaySpeed: 2500,
        //     className: 'ha-slider'
        // };

        // const quoteSlides = 
        // sliderQuotes.map((quote, index) => {
        //     return (
        //         <div key={ index } className="ha-slide quote-slide">
        //             <div className="quote">{ quote }</div>
        //         </div>
        //     );
        // });

        // const pressSlidesMobile = pressdata.map((press, index) => {
        //     return (
        //         <div key={ index } className="ha-slide">
        //             <LookWhosTalkingSlide path={ press.path } />
        //         </div>
        //     );
        // });

        return (
            <div id="look-whos-talking-slider">
                <Slider { ...sliderSettings } >
                    { this.renderSlides() }
                </Slider>
            </div>
        );
    }
}


export default LookWhosTalkingSlider;



// WEBPACK FOOTER //
// ./src/components/explain/LookWhosTalkingSlider.js